import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import SideMenu from './components/SideMenu';
import Cards from './pages/Cards';
import Contacts from './pages/Contacts';
import Backgrounds from './pages/Backgrounds';
import EmailSignatures from './pages/EmailSignatures';
import Analytics from './pages/Analytics';
import CardForm from './pages/CardForm';
import Settings from './pages/Settings';
import EditCard from './pages/EditCard'; // Ensure correct path
import ViewCard from './pages/ViewCard';
import HomePage from './pages/HomePage';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import Platform from './pages/Platform';
import Solutions from './pages/Solutions';
import Resources from './pages/Resources';
import Pricing from './pages/Pricing';
import Subscriptions from './pages/Subscriptions'; // Ensure correct path
import Login from './pages/Login';
import Signup from './pages/Signup';
import VerifyCode from './pages/VerifyCode'; // Ensure correct path

function App() {
    const location = useLocation();
    
    const noHeaderSideMenuPaths = [
        '/', 
        '/contact', 
        '/about', 
        '/platform', 
        '/solutions', 
        '/resources', 
        '/pricing', 
        '/login', 
        '/signup',
        '/verify-code'
    ];
    
    // Regex to match dynamic routes like /card/:uuid
    const dynamicNoHeaderSideMenuPaths = [
        /^\/card\/[^/]+$/  // Matches /card/ followed by any characters except /
    ];

    const shouldShowHeaderSideMenu = !noHeaderSideMenuPaths.includes(location.pathname) &&
        !dynamicNoHeaderSideMenuPaths.some((pattern) => pattern.test(location.pathname));

    return (
        <div className="App">
            {shouldShowHeaderSideMenu && <Header />}
            {shouldShowHeaderSideMenu && <SideMenu />}
            <div className={shouldShowHeaderSideMenu ? "content" : "content-no-sidebar"}>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/cards" element={<Cards />} />
                    <Route path="/contacts" element={<Contacts />} />
                    <Route path="/backgrounds" element={<Backgrounds />} />
                    <Route path="/emailsignatures" element={<EmailSignatures />} />
                    <Route path="/analytics" element={<Analytics />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/new-card" element={<CardForm />} /> 
                    <Route path="/edit-card/:id" element={<EditCard />} />
                    <Route path="/card/:uuid" element={<ViewCard />} />
                    <Route path="/contact" element={<ContactUs />} />
                    <Route path="/about" element={<AboutUs />} />
                    <Route path="/platform" element={<Platform />} />
                    <Route path="/solutions" element={<Solutions />} />
                    <Route path="/resources" element={<Resources />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/subscriptions" element={<Subscriptions />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/verify-code" element={<VerifyCode />} />
                </Routes>
            </div>
        </div>
    );
}

export default App;

